export default [
  {
    id: 'profile',
    title: '프로필',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'address',
    title: '주소',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'contacts',
    title: '연락처',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'id-photo',
    title: '증명사진',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'edu-history',
    title: '학력',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'job-history',
    title: '이력',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'license-history',
    title: '면허・자격증',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'reason',
    title: '지원동기',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'requests',
    title: '본인희망',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'create-date',
    title: '작성일',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'confirm',
    title: '확인',
    previewJumpId: 'confirm-preview'
  },
  {
    id: 'output',
    title: '다운로드',
    previewJumpId: 'close-preview-button-above'
  }
]
